// @flow

import { createSelector } from 'reselect';

const selectUserState = () => (state) => state.get('user');
const selectUserErrors = () =>
    createSelector(selectUserState(), (substate) => substate.get('userErrors'));

export { selectUserErrors };
